import React, { useEffect, useMemo, useState } from "react";
import { doc, getDoc, collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useSession } from "../auth.jsx";
import { Eyebrow } from "../components/Bits.jsx";
import { instructionalWeek } from "../lib/pace.js";

/** Staff prep view: this week's position notes from your cluster, read before you teach. */
export default function Seminar() {
  const s = useSession();
  const [cohort, setCohort] = useState(null);
  const [week, setWeek] = useState(null);
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    if (!s.profile?.cohortId) return;
    getDoc(doc(db, "cohorts", s.profile.cohortId)).then((d) => d.exists() && setCohort(d.data()));
  }, [s.profile?.cohortId]);

  const now = useMemo(() => instructionalWeek(cohort?.startDate), [cohort]);
  const w = week ?? now.week;

  useEffect(() => {
    if (!s.profile?.cohortId) return;
    const clauses = [where("cohortId", "==", s.profile.cohortId), where("week", "==", w)];
    if (s.role === "master" && s.profile?.clusterId) clauses.push(where("clusterId", "==", s.profile.clusterId));
    return onSnapshot(query(collection(db, "notes"), ...clauses), (snap) =>
      setNotes(snap.docs.map((d) => ({ id: d.id, ...d.data() }))));
  }, [s.profile?.cohortId, s.profile?.clusterId, s.role, w]);

  return (
    <div style={{ maxWidth: 820 }}>
      <div className="row between wrapflex">
        <div>
          <Eyebrow>Seminar prep</Eyebrow>
          <h1 style={{ fontSize: 24, marginTop: 4 }}>Position notes · week {w}</h1>
        </div>
        <div className="row" style={{ gap: 4 }}>
          <button className="btn ghost" onClick={() => setWeek(Math.max(0, w - 1))}>←</button>
          <button className="btn ghost" onClick={() => setWeek(Math.min(24, w + 1))}>→</button>
        </div>
      </div>
      <p style={{ color: "var(--graphite)", maxWidth: "64ch" }}>
        Read these before you teach — the seminar answers the room you actually have, not the one the
        slides imagine. Quote the good ones by name in session; being cited is the cheapest motivation there is.
      </p>
      {notes.map((n) => (
        <div key={n.id} className="card" style={{ marginTop: 12 }}>
          <div className="mono" style={{ fontSize: 11, color: "var(--graphite)" }}>
            {(n.residentUid || "").slice(0, 8)} · pod {n.podId ?? "—"}
          </div>
          <p style={{ marginTop: 6, whiteSpace: "pre-wrap" }}>{n.text}</p>
        </div>
      ))}
      {!notes.length && <p style={{ marginTop: 16, color: "var(--graphite)", fontStyle: "italic" }}>Nothing filed for this week yet in your view.</p>}
    </div>
  );
}
